var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6977 6.27907C10.4959 6.27907 6.27907 10.4959 6.27907 15.6977C6.27907 20.8994 10.4959 25.1163 15.6977 25.1163C20.8994 25.1163 25.1163 20.8994 25.1163 15.6977C25.1163 10.4959 20.8994 6.27907 15.6977 6.27907ZM0 15.6977C0 7.02808 7.02808 0 15.6977 0C24.3673 0 31.3953 7.02808 31.3953 15.6977C31.3953 24.3673 24.3673 31.3953 15.6977 31.3953C7.02808 31.3953 0 24.3673 0 15.6977ZM37.6744 15.6977C37.6744 13.9638 39.0801 12.5581 40.814 12.5581H62.2963C73.813 12.5581 78.1928 27.5986 68.4766 33.7817L24.8945 61.5156C20.478 64.3261 22.4689 71.1628 27.7038 71.1628H41.6064L40.6871 70.2431C39.461 69.017 39.461 67.0295 40.6871 65.8034C41.9132 64.5773 43.9007 64.5773 45.1268 65.8034L51.4059 72.0825C52.632 73.3086 52.632 75.2961 51.4059 76.5222L45.1268 82.8013C43.9007 84.0274 41.9132 84.0274 40.6871 82.8013C39.461 81.5752 39.461 79.5876 40.6871 78.3615L41.6064 77.4419H27.7038C16.1869 77.4419 11.8072 62.4014 21.5235 56.2182L65.1056 28.4843C69.5219 25.6738 67.531 18.8372 62.2963 18.8372H40.814C39.0801 18.8372 37.6744 17.4316 37.6744 15.6977ZM74.3023 64.8837C69.1007 64.8837 64.8837 69.1007 64.8837 74.3023C64.8837 79.5039 69.1007 83.7209 74.3023 83.7209C79.5039 83.7209 83.7209 79.5039 83.7209 74.3023C83.7209 69.1007 79.5039 64.8837 74.3023 64.8837ZM58.6047 74.3023C58.6047 65.6326 65.6326 58.6047 74.3023 58.6047C82.972 58.6047 90 65.6326 90 74.3023C90 82.972 82.972 90 74.3023 90C65.6326 90 58.6047 82.972 58.6047 74.3023Z",
    fill: "url(#paint0_linear_310_32867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_32867",
    x1: 1.78783e-8,
    y1: 45,
    x2: 89.9998,
    y2: 45.1493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocol);
export default __webpack_public_path__ + "static/media/protocol.a14ef4a1b4ee0740bec2a0af17fec383.svg";
export { ForwardRef as ReactComponent };